// extracted by mini-css-extract-plugin
module.exports = {"icon":"_29lZT","iconMini":"_3YY9V"};